"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ServiceHeroCustom() {
  const [loaded, setLoaded] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => {
      clearTimeout(t);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  const headline1 = "Precision in";
  const headline2 = "Engineering.";
  return <section data-section-id="3858" id="service-hero-custom" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0" style={{
      transform: `scale(${1 + Math.min(scrollY, 600) / 6000})`,
      transition: "transform 0.1s linear"
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_blueprint_hero.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_blueprint_hero.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_blueprint_hero.webp-wvc-sizes" alt="High-precision industrial engineering blueprint and components" className="h-full w-full object-cover" loading="eager" decoding="async" />
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-10" style={{
      background: "radial-gradient(ellipse at center, hsla(216, 50%, 12%, 0.2) 0%, hsla(216, 50%, 12%, 0.55) 60%, hsla(216, 50%, 12%, 0.85) 100%)"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 z-10 opacity-[0.05] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      {}
      <div className="absolute right-6 top-1/2 z-20 hidden -translate-y-1/2 md:block lg:right-10">
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-foreground/70" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          — Phase One / The Blueprint
        </div>
      </div>

      {}
      <div className="relative z-20 flex min-h-screen w-full flex-col">
        {}
        <div className="flex-1" />

        <div className="w-full px-6 pb-16 sm:px-10 md:pb-20 lg:px-16 lg:pb-24">
          <div className="max-w-3xl text-center md:text-left">
            {}
            <div className={`mb-6 flex items-center justify-center gap-4 transition-all duration-1000 md:justify-start ${loaded ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
              <span className="block h-px w-10" style={{
              backgroundColor: "var(--chart-1)"
            }} />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-foreground/80">
                N°01 — Concept to Reality · Est. 2014
              </span>
            </div>

            {}
            <h1 className="font-default font-light leading-[0.95] text-foreground" style={{
            fontSize: "clamp(3.5rem, 9vw, 8rem)"
          }}>
              <span className="block overflow-hidden">
                {headline1.split("").map((char, i) => <span key={`l1-${i}`} data-index={i} className="inline-block transition-all" style={{
                transitionDuration: "1400ms",
                transitionDelay: `${200 + i * 35}ms`,
                transform: loaded ? "translateY(0)" : "translateY(110%)",
                opacity: loaded ? 1 : 0
              }}>
                    {char === " " ? "\u00A0" : char}
                  </span>)}
              </span>
              <span className="block overflow-hidden italic" style={{
              color: "var(--chart-1)"
            }}>
                {headline2.split("").map((char, i) => <span key={`l2-${i}`} data-index={i} className="inline-block transition-all" style={{
                transitionDuration: "1400ms",
                transitionDelay: `${600 + i * 50}ms`,
                transform: loaded ? "translateY(0)" : "translateY(110%)",
                opacity: loaded ? 1 : 0
              }}>
                    {char === " " ? "\u00A0" : char}
                  </span>)}
              </span>
            </h1>

            {}
            <p className={`mt-8 max-w-xl text-base font-default leading-relaxed text-foreground/75 transition-all duration-1000 sm:text-lg md:mx-0 mx-auto ${loaded ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
            transitionDelay: "1400ms"
          }}>
              Advanced mechanical solutions and precision engineering for industries that demand absolute reliability.
            </p>

            {}
            <div className={`mt-10 flex flex-col items-center gap-5 transition-all duration-1000 sm:flex-row md:items-start ${loaded ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
            transitionDelay: "1600ms"
          }}>
              <Link to="/CapabilitiesPage">
                <Button variant="outline" size="lg" className="group h-12 border bg-transparent px-7 font-mono text-[11px] uppercase tracking-[0.25em] transition-all duration-300 hover:bg-transparent" style={{
                borderColor: "var(--chart-1)",
                color: "var(--chart-1)"
              }}>
                  View Capabilities
                  <ArrowRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Button>
              </Link>

              <Link to="/ContactPage">
                <Button variant="link" className="group h-12 px-2 font-mono text-[11px] uppercase tracking-[0.25em] text-foreground hover:no-underline">
                  <span className="relative">
                    Contact Us
                    <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-100 transition-transform duration-500 group-hover:scale-x-0" style={{
                    backgroundColor: "var(--foreground)"
                  }} />
                    <span className="absolute -bottom-1 left-0 h-px w-full origin-right scale-x-0 transition-transform duration-500 group-hover:scale-x-100" style={{
                    backgroundColor: "var(--chart-1)"
                  }} />
                  </span>
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 right-6 z-20 hidden flex-col items-center gap-3 md:flex lg:right-10">
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground/60">
          Scroll
        </span>
        <div className="relative h-12 w-px overflow-hidden bg-foreground/20">
          <span className="absolute left-1/2 top-0 block size-1.5 -translate-x-1/2 rounded-lg" style={{
          backgroundColor: "var(--chart-1)",
          animation: "echoScrollDot 3s ease-in-out infinite"
        }} />
        </div>
      </div>

      <style>{`
        @keyframes echoScrollDot {
          0% { transform: translate(-50%, -100%); opacity: 0; }
          20% { opacity: 1; }
          80% { opacity: 1; }
          100% { transform: translate(-50%, 48px); opacity: 0; }
        }
      `}</style>
    </section>;
}